var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"common-loading",on:{"touchmove":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"loading-con"},[_c('van-loading',{attrs:{"color":"#fff"}}),_c('div',{staticClass:"loading-text"},[_vm._v("加载中...")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }